/** Inscription institution — fusionné dans institutionOverlay (fr/en). */

export const institutionRegisterStringsFr: Record<string, string> = {
  'auth.institutionRegister': 'Inscription institution',
  'auth.institutionRegister.pageTitle': 'Inscription institution',
  'auth.institutionRegister.steps.institution': 'Institution',
  'auth.institutionRegister.steps.contact': 'Contact',
  'auth.institutionRegister.steps.plan': 'Votre projet',
  'auth.institutionRegister.quoteTitle': 'Tarification sur devis',
  'auth.institutionRegister.quoteIntro':
    'L’offre est établie avec vous selon le nombre d’établissements, d’apprenants et les options retenues. Décrivez votre projet : nous revenons vers vous avec une proposition.',
  'auth.institutionRegister.projectLabel': 'Votre projet (facultatif)',
  'auth.institutionRegister.projectPlaceholder': 'Nombre d’établissements, calendrier, langues, contraintes de connexion…',
  'auth.institutionRegister.institutionName': "Nom de l'institution *",
  'auth.institutionRegister.institutionNamePlaceholder': 'Université de Paris',
  'auth.institutionRegister.typeLabel': "Type d'institution *",
  'auth.institutionRegister.sizeLabel': "Taille (nombre d'apprenants) *",
  'auth.institutionRegister.selectPlaceholder': 'Sélectionner…',
  'auth.institutionRegister.type.university': 'Université',
  'auth.institutionRegister.type.school': 'École',
  'auth.institutionRegister.type.training_center': 'Centre de formation',
  'auth.institutionRegister.type.enterprise': 'Entreprise',
  'auth.institutionRegister.type.association': 'Association',
  'auth.institutionRegister.type.other': 'Autre',
  'auth.institutionRegister.size.1_50': '1 – 50',
  'auth.institutionRegister.size.51_200': '51 – 200',
  'auth.institutionRegister.size.201_1000': '201 – 1 000',
  'auth.institutionRegister.size.1000_plus': '1 000+',
  'auth.institutionRegister.firstName': 'Prénom *',
  'auth.institutionRegister.lastName': 'Nom *',
  'auth.institutionRegister.workEmail': 'E-mail professionnel *',
  'auth.institutionRegister.workEmailPlaceholder': 'admin@institution.fr',
  'auth.institutionRegister.phone': 'Téléphone',
  'auth.institutionRegister.phonePlaceholder': '+33 1 23 45 67 89',
  'auth.institutionRegister.previous': 'Précédent',
  'auth.institutionRegister.next': 'Suivant',
  'auth.institutionRegister.sending': 'Envoi…',
  'auth.institutionRegister.createAccount': 'Créer le compte',
  'auth.institutionRegister.submitRequest': 'Envoyer la demande',
  'auth.institutionRegister.successTitle': 'Demande envoyée',
  'auth.institutionRegister.successBody':
    'Merci. L’équipe LyrraStudio ouvre votre établissement et envoie les identifiants administrateur à {{email}}.',
  'auth.institutionRegister.submitError': 'Envoi impossible. Réessayez ou écrivez à support@lyrrastudio.com.',
};

export const institutionRegisterStringsEn: Record<string, string> = {
  'auth.institutionRegister': 'Institution sign-up',
  'auth.institutionRegister.pageTitle': 'Institution sign-up',
  'auth.institutionRegister.steps.institution': 'Organization',
  'auth.institutionRegister.steps.contact': 'Contact',
  'auth.institutionRegister.steps.plan': 'Your project',
  'auth.institutionRegister.quoteTitle': 'Pricing on quotation',
  'auth.institutionRegister.quoteIntro':
    'The offer is built with you based on the number of establishments, learners and selected options. Describe your project: we will come back to you with a proposal.',
  'auth.institutionRegister.projectLabel': 'Your project (optional)',
  'auth.institutionRegister.projectPlaceholder': 'Number of establishments, timeline, languages, connectivity constraints…',
  'auth.institutionRegister.institutionName': 'Organization name *',
  'auth.institutionRegister.institutionNamePlaceholder': 'e.g. City University',
  'auth.institutionRegister.typeLabel': 'Organization type *',
  'auth.institutionRegister.sizeLabel': 'Size (number of learners) *',
  'auth.institutionRegister.selectPlaceholder': 'Select…',
  'auth.institutionRegister.type.university': 'University',
  'auth.institutionRegister.type.school': 'School',
  'auth.institutionRegister.type.training_center': 'Training center',
  'auth.institutionRegister.type.enterprise': 'Company',
  'auth.institutionRegister.type.association': 'Non-profit / association',
  'auth.institutionRegister.type.other': 'Other',
  'auth.institutionRegister.size.1_50': '1 – 50',
  'auth.institutionRegister.size.51_200': '51 – 200',
  'auth.institutionRegister.size.201_1000': '201 – 1,000',
  'auth.institutionRegister.size.1000_plus': '1,000+',
  'auth.institutionRegister.firstName': 'First name *',
  'auth.institutionRegister.lastName': 'Last name *',
  'auth.institutionRegister.workEmail': 'Work email *',
  'auth.institutionRegister.workEmailPlaceholder': 'admin@organization.com',
  'auth.institutionRegister.phone': 'Phone',
  'auth.institutionRegister.phonePlaceholder': '+1 555 123 4567',
  'auth.institutionRegister.previous': 'Back',
  'auth.institutionRegister.next': 'Next',
  'auth.institutionRegister.sending': 'Sending…',
  'auth.institutionRegister.createAccount': 'Create account',
  'auth.institutionRegister.submitRequest': 'Send the request',
  'auth.institutionRegister.successTitle': 'Request sent',
  'auth.institutionRegister.successBody':
    'Thank you. The LyrraStudio team opens your establishment and sends the administrator credentials to {{email}}.',
  'auth.institutionRegister.submitError': 'Sending failed. Try again or email support@lyrrastudio.com.',
};
